/**
 * Environment variables
 */

// per environment
const local = {
  debug: true,
  testUser: true,
  strapiAPI: {
    URL: 'https://api.gallery.revanceu.com/' // remote dev - new
  },
  revanceAPI: {
    URL: 'https://revanceapi.azurewebsites.net',
    // URL: 'https://revanceu.com'
  },
  revanceSSOEndpoint: {
    URL: 'https://revanceu-studio-staging.viscira.net'
  },
  revanceSSOLogout: {
    URL: 'https://parcopy-revanceready.cs97.force.com/secur/logout.jsp'
  },
  revanceUPortalLink: {
    URL: 'https://revanceapi.azurewebsites.net/'
  },
  modules: [
    {
      key: 'anatomy',
      cmid: 22,
      path: 'https://revance-relative-dev.viscira.net/revance/module4/',
      pathMode: 'full'
    },
    {
      key: 'clinical_guidance',
      cmid: 9999, // TODO
      path: 'https://revance-relative-dev.viscira.net/revance/module7/',
      pathMode: 'full'
    }
  ]
};

// dev - point to Strapi API dev & Revance API staging
const development = {
  debug: true,
  testUser: true,
  strapiAPI: {
    URL: 'https://api.gallery.revanceu.com/'
  },
  revanceAPI: {
    URL: 'https://revanceapi.azurewebsites.net'
  },
  revanceSSOEndpoint: {
    URL: 'https://revanceu-studio-staging.viscira.net'
  },
  revanceSSOLogout: {
    URL: 'https://parcopy-revanceready.cs97.force.com/secur/logout.jsp'
  },
  revanceUPortalLink: {
    URL: 'https://revanceapi.azurewebsites.net/'
  },
  modules: [
    {
      key: 'anatomy',
      cmid: 22,
      path: '/revance/module4/',
      pathMode: 'absolute'
    },
    {
      key: 'clinical_guidance',
      cmid: 9999,
      path: '/revance/module7/',
      pathMode: 'absolute'
    }
  ]
};

// qa - point to Strapi API dev & Revance API staging
const qa = {
  debug: false,
  testUser: true,
  strapiAPI: {
    URL: 'https://api.gallery.revanceu.com/'
  },
  revanceAPI: {
    URL: 'https://revanceapi.azurewebsites.net'
  },
  revanceSSOEndpoint: {
    URL: 'https://revanceu-studio-staging.viscira.net'
  },
  revanceSSOLogout: {
    URL: 'https://parcopy-revanceready.cs97.force.com/secur/logout.jsp'
  },
  revanceUPortalLink: {
    URL: 'https://revanceapi.azurewebsites.net/'
  },
  modules: [
    {
      key: 'anatomy',
      cmid: 22,
      path: '/revance/module4/',
      pathMode: 'absolute'
    },
    {
      key: 'clinical_guidance',
      cmid: 9999,
      path: '/revance/module7/',
      pathMode: 'absolute'
    }
  ]
};

const staging = {
  debug: false,
  testUser: false,
  strapiAPI: {
    URL: 'https://api.gallery.revanceu.com/'
  },
  revanceAPI: {
    URL: 'https://revanceapi.azurewebsites.net'
  },
  revanceSSOEndpoint: {
    URL: 'https://revanceu-studio-staging.viscira.net'
  },
  revanceSSOLogout: {
    URL: 'https://parcopy-revanceready.cs97.force.com/secur/logout.jsp'
  },
  revanceUPortalLink: {
    URL: 'https://revanceapi.azurewebsites.net/'
  },
  modules: [
    {
      key: 'anatomy',
      cmid: 22,
      path: '/revance/module4/',
      pathMode: 'absolute'
    },
    {
      key: 'clinical_guidance',
      cmid: 9999,
      path: '/revance/module7/',
      pathMode: 'absolute'
    }
  ]
};

const production = {
  debug: false,
  testUser: false,
  strapiAPI: {
    URL: 'https://api.gallery.revanceu.com/'
  },
  revanceAPI: {
    URL: 'https://revanceu.com'
  },
  revanceSSOEndpoint: {
    URL: 'https://gallery.revanceu.com'
  },
  revanceSSOLogout: {
    URL: 'https://hcp.revanceready.com/secur/logout.jsp'
  },
  revanceUPortalLink: {
    URL: 'https://revanceu.com'
  },
  module: {
    path: '/revance/module4/',
    pathMode: 'absolute'
  },
  modules: [
    {
      key: 'anatomy',
      cmid: 10,
      path: '/revance/module4/',
      pathMode: 'absolute'
    },
    {
      key: 'clinical_guidance',
      cmid: 9999,
      path: '/revance/module7/',
      pathMode: 'absolute'
    }
  ]
};

let env_config = local;

switch (process.env.REACT_APP_STAGE) {
  case 'development':
      env_config = development;
      break;
  case 'qa':
      env_config = qa;
      break;
  case 'staging':
      env_config = staging;
      break;
  case 'production':
      env_config = production;
      break;
  default:
      env_config = local;
      break;
}

// globals
const config = {
  title: 'RevanceU Gallery',
  // define the feature set per project
  features: {
    userAuthentication: true, // whether or not user authentication is required to access pages protected by a PrivateRoute
  },
  gaTrackingId: 'UA-165290226-10',
  ...env_config
};

export default config;



// WEBPACK FOOTER //
// ./src/config.ts